<template>
  <v-card class="mb-2" outlined>
    <v-card-text class="pa-3">
      <div class="d-flex align-center">
        <v-checkbox v-model="selected" class="ma-0 pa-0 mr-3" hide-details @change="$emit('toggle', optionProduct)"></v-checkbox>
        <div class="flex-grow-1">
          <div class="font-weight-medium">{{ getTitle(optionProduct) }}</div>
          <div class="text-caption font-weight-bold">{{ optionProduct.price.toLocaleString() }}원</div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "OptionProductCard",
  props: {
    optionProduct: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.value,
    }
  },
  watch: {
    value(newVal) {
      this.selected = newVal
    },
  },
  methods: {
    getTitle(product) {
      if (typeof product.title === "string") {
        try {
          const parsed = JSON.parse(product.title)
          return parsed.kr || product.title
        } catch {
          return product.title
        }
      } else if (product.title && typeof product.title === "object") {
        return product.title.kr || ""
      }
      return ""
    },
  },
}
</script>
